import { render } from "./UnavailabilityCategoryFeature.vue?vue&type=template&id=2541211a&ts=true"
import script from "./UnavailabilityCategoryFeature.vue?vue&type=script&lang=ts"
export * from "./UnavailabilityCategoryFeature.vue?vue&type=script&lang=ts"

import "./UnavailabilityCategoryFeature.vue?vue&type=style&index=0&id=2541211a&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__